<script lang="ts">
  import { getFileNameFromPath } from '$shared/helpers/utils';

  interface Props {
    value?: string[];
    title?: string;
    onevent?: (payload: { type: 'click-attachment'; data: { path: string } }) => void;
  }

  let { value = [], title = '', onevent }: Props = $props();

  const onClickAttachment = (path): void => {
    onevent?.({ type: 'click-attachment', data: { path } });
  };
</script>

<div class="comp-attachment-list-type">
  {#if Array.isArray(value) && value?.length > 0}
    <div data-cy="attachment-header" class="header">
      <div class="title">{title || 'Attachments'}</div>
    </div>
    {#each value as path, index}
      <a
        class="list-i"
        href="/"
        data-cy={`attachment-${index}`}
        onclick={(e) => { e.preventDefault(); onClickAttachment(path); }}
      >
        <div class="text">{getFileNameFromPath(path)}</div>
      </a>
    {/each}
  {/if}
</div>

<style>
  .comp-attachment-list-type {
    width: 100%;
    align-items: flex-start;
    padding: 12px 16px;
    line-height: 20px;
    background-color: white;
  }
  .list-i {
    width: 100%;
    display: flex;
    align-items: center;
    font-size: 14px;
    line-height: 20px;
    color: var(--blue);
    text-decoration: none;
    padding: 12px 16px;
  }
  .list-i:nth-child(even) {
    background-color: var(--grey-bg);
  }
  .header .title {
    width: 150px;
    flex-shrink: 0;
    margin: 0px 16px 10px 0px;
    overflow: hidden;
    color: var(--black);
    font-weight: 500;
  }
</style>
